import { StudyMissionStatus } from '../types/meia/backend-persistence.types';
/**
 * Single source of truth for the mission lifecycle. Both the API (transition
 * enforcement) and the web app (transition affordances) derive from this map, so
 * the legal-transition graph cannot drift between client and server.
 */
export const LEGAL_MISSION_STATUS_TRANSITIONS = {
    [StudyMissionStatus.ACTIVE]: [StudyMissionStatus.DRAFT, StudyMissionStatus.UNDER_REVIEW, StudyMissionStatus.CLOSED],
    [StudyMissionStatus.CLOSED]: [StudyMissionStatus.ACTIVE, StudyMissionStatus.UNDER_REVIEW],
    [StudyMissionStatus.DRAFT]: [StudyMissionStatus.ACTIVE],
    [StudyMissionStatus.UNDER_REVIEW]: [StudyMissionStatus.ACTIVE, StudyMissionStatus.CLOSED],
};
export const getLegalMissionStatusTransitions = (status) => LEGAL_MISSION_STATUS_TRANSITIONS[status];
/** Q-RFT-03 / BV-RFT-06: leaving Closed requires an explicit reason of at least this length. */
export const MISSION_STATUS_REASON_MIN_LENGTH = 30;
export const shouldRequireMissionStatusReason = (currentStatus) => currentStatus === StudyMissionStatus.CLOSED;
